import { useEffect, useState } from "react";
import "./CourseCard1.css";
import fallback_img from "./img/fallback_img.jpg"
import loading_img from "./img/loadingImg.jpg";

import the404Img from "../UI/404/404ErrorTwo.png"
import placeholderImg from "../UI/Placeholder/thumbnailPlaceholder.png"
import CourseCard1MouseOver from "./CourseCard1MouseOver";
import CourseCard1PopUp from "./CourseCard1PopUp";
import { ChevronDown, ChevronsDown, ChevronUp, Filter, X } from "lucide-react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getAllProductsByAppForClients } from "../../store/actions/CreateCourse/CourseApi";
import DropDownButtonUI from "../UI/DropDownButtonUI";
import Toggle from "../UI/Toggle";
import BannerUI from "../UI/BannerUI";
import CourseCardV1 from "../CourseCard/CourseCardV1";
import CartSidebar from "../Cart/CartSidebar";
import ErrorNotFound from "../UI/404/ErrorNotFound";

const CourseCard1= ({courseThemeCard1Object})=>{
  
 const [isCartOpen, setCartOpen] = useState(false);

const [hoverCourseCard, setHoverCourseCard] = useState(false);
const [popUpItem, setPopUpItem] = useState({});
     
const [showFilterSidebar,setShowFilterSidebar] = useState(true);


         const [stateFree, setStateFree] = useState(false);
         const [statePaid, setStatePaid] = useState(false);
         const [languagesFilter, setLanguagesFilter] = useState([]);
         const [difficultyFilter, setDifficultyLevelFilter] = useState([]);
         const [statusFilter, setStatusFilter] = useState([]);
         const [typeFilter, setTypeFilter] = useState([]);
         const [languagesFilterOpen, setLanguagesFilterOpen] = useState(true);
         const [difficultyFilterOpen, setDifficultyLevelFilterOpen] = useState(true);
         const [statusFilterOpen, setStatusFilterOpen] = useState(true);
         const [typeFilterOpen, setTypeFilterOpen] = useState(false);
         const [filtersChips, setFilterChips] = useState({});
         const [activeDropdown , setActiveDropdown] = useState("A-Z")

     const dispatch = useDispatch();
         const user = useSelector((state)=>state?.user?.user);
              
         const [snackbarVisible, setSnackbarVisible] = useState(false);
                          const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                          const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                    
                           
                       const showSnackbar = () => {
                         setSnackbarVisible(true);
                       };
                      
                       const hideSnackbar = () => {
                         setSnackbarVisible(false);
                       };
                 
                 
                            
                            
                         
                        const [animate, setAnimate] = useState(false);
          
           const [loader , setLoader] =useState({status:true});
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }

      
   
            const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
            
            const courseData = useSelector((state)=>state?.course?.course);
       
               
               const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
              const appId = useSelector((state)=>state?.app?.app?.ID);
                    const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
                        
                
                 const [visibility,setVisibility] =useState("public");
                 const [orderBy,setOrderBy] =useState("ASC");
                 const [itemArr, setItemArr] = useState([]);
                 const [itemArrAll, setItemArrAll] = useState([]);
                 const [itemReorderArr, setItemReorderArr] = useState([]);
                 
                  const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{}]);
                 const [itemId, setItemId] = useState("");
                 const [currentItem, setCurrentItem] = useState({});
                     const currentToken = useSelector((state)=>state?.user?.user?.currentToken);
               const userEmail = useSelector((state)=>state?.user?.user?.userData?.userEmail
              );   

const parseLabel = (label) => {
  if (!label) return null;
  try {
    return JSON.parse(label);
  } catch {
    return null;
  }
};



const [filters, setFilters] = useState({
    languageLabel: [],
    statusLabel: [],
    difficultyLabel: [],
    typeLabel: [],
  

  priceType:[],   // "free" | "paid" | null
  sortBy: [], 
  });

const applyFilters = (courses, filters) => {
  let filtered = [...courses];

  // ---------------------------------
  // 1️⃣ LABEL FILTERS (post_title based)
  // ---------------------------------
  const LABEL_KEYS = ["languageLabel", "statusLabel", "difficultyLabel", "typeLabel"];

  filtered = filtered.filter((course) => {
    return LABEL_KEYS.every((filterType) => {
      const values = filters[filterType];

      if (!values || values?.length === 0) return true; // no filter applied

      const parsed = parseLabel(course[filterType]);
      if (!parsed) return false;

      return values.includes(parsed?.post_title);
    });
  });

  // ---------------------------------
  // 2️⃣ PRICE FILTERS (free / paid)
  // priceType is now an ARRAY
  // ---------------------------------
  if (filters?.priceType?.length > 0) {
    filtered = filtered?.filter((course) => {
      const noProduct = course?.price?.product === null;
      const freePlan = course?.price?.pricePlan?.pricePlanType === "freePlan";
      const isFree = noProduct || freePlan;

      const type = course?.price?.pricePlan?.pricePlanType;
      const isPaid = type && type !== "freePlan";

      return (
        (filters?.priceType.includes("free") && isFree) ||
        (filters?.priceType.includes("paid") && isPaid)
      );
    });
  }

  // ---------------------------------
  // 3️⃣ SORTING (use first element only)
  // sortBy is array but only 1 sorting rule makes sense
  // ---------------------------------
  if (filters?.sortBy?.length > 0) {
    const sortRule = filters?.sortBy[0];

    filtered?.sort((a, b) => {
      const priceA = Number(a?.price?.pricePlan?.effectivePriceWeb ?? 0);
      const priceB = Number(b?.price?.pricePlan?.effectivePriceWeb ?? 0);

      if (sortRule === "A-Z") return priceA - priceB;
      if (sortRule === "desc") return priceB - priceA;

      if (sortRule === "rating-high") return (b.rating ?? 0) - (a.rating ?? 0);
      if (sortRule === "rating-low") return (a.rating ?? 0) - (b.rating ?? 0);

      return 0;
    });
  }

  return filtered;
};
const toggleFilter = (filterType, value) => {
  setFilters((prev) => {
    let updatedFilters = { ...prev };

    const alreadySelected = prev[filterType]?.includes(value);

    updatedFilters[filterType] = alreadySelected
      ? prev[filterType].filter((v) => v !== value) // remove
      : [...prev[filterType], value];               // add

    // show skeleton loaders
    setItemArrLoading([{},{},{},{}]);

    setTimeout(() => {
      const newData = applyFilters(itemArrAll, updatedFilters);
      setItemArr(newData);
      setItemArrLoading([]);
      setFilterChips(updatedFilters);
    }, 400);

    return updatedFilters;
  });
};



 


useEffect((e)=>{
      
    fireGetAllCoursesByApp();
        },[visibility,orderBy,postIdCourse]);
  const fireGetAllCoursesByApp=()=>{
          setItemArr([])
         
        
                
          // if(visibility=='public'){setActiveFilterTwo(true)}
          // if(openAppDesignPopUp){setActiveFilterTwo(true);setVisibility('public');}
          
        
          setItemArrLoading([{},{},{},{}])
        // Popup When Course is not selected
          if(courseData){}else{}
        
        setLoader({status:true});
           
              const apiData = dispatch(getAllProductsByAppForClients({userEmail:userEmail?userEmail:"",
       currentToken:currentToken?currentToken:"",
                     visibility:visibility,orderBy:orderBy,type:"course"}));
              /* get response as Promise   */
              apiData.then(response => {
                console.log(response)
        
                if(response){
                 
                  if(response){
                setResponseMessage(response?.message);
                setSnackbarColor("rgba(144, 202, 249,1)");
              
                if(response?.products)  {setItemArr(response?.products); 
                    setItemArrAll(response?.products); 
                         const data = response?.products;


function extractUnique(field) {
  const unique = [];
  data.forEach(item => {
    if (item[field]) {
      try {
        const parsed = JSON.parse(item[field]);
        if (!unique.some(u => u.ID === parsed.ID)) {
          unique.push(parsed);
        }
      } catch (e) {
        // ignore invalid JSON
      }
    }
  });
  return unique;
}
const languages = extractUnique("languageLabel");
const difficulties = extractUnique("difficultyLabel");
const statuses = extractUnique("statusLabel");
const types = extractUnique("typeLabel");

      setLanguagesFilter(languages)   ;  
      setDifficultyLevelFilter(difficulties) ;
      setStatusFilter(statuses)  ;
      setTypeFilter(types)  ; 
               
                }else{setItemArr([]);};
                setItemArrLoading([]);
            setLoader({status:false});
            
            // setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
            },1000)
               }else{
           
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
               }
                  
                
               if(response?.logout){
               
                setResponseMessage("You are Logged Out!!!");
                  
                setSnackbarColor("#958FDA");
              
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                setTimeout(()=>{
                  dispatch({type:"LOGOUT"});
            
                },3000)
                
              }
            
                }else{
                  setResponseMessage("Something Went Wrong...");
                  
                  setSnackbarColor("#958FDA");
                
                setItemArrLoading([{},{},{},{}])
                   
              setLoader({status:false});
              
              setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
               
                 
              },3000)    }
            
              }).catch(error => {
             
                //popup of error Info
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("#958FDA");
             
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                console.error(error);
              });
         }




  const flattenedData = itemArr!=[]?Object.values(itemArr):'';

         const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
 




return(<>



<div className="courseFilterCardsOuter">
    <div></div>
     <div className="hideMD hideSM hideLG" style={{background:"rgba(105, 95, 95,0.1)",width:"30px",height:"30px",marginTop:"25px",borderRadius:"50%",position:"absolute",botttom:"0px",right:"0px",
                     alignContent:"center",textAlign:"center",padding:"5px",margin:"10px",cursor:"pointer"}} onClick={()=>setShowFilterSidebar(true)} >
                        <Filter size={22}  color="rgb(105, 95, 95)"/></div>
    {showFilterSidebar?<div className="CourseFilterLeft"> 
        <div  className="hideMD hideSM hideLG"  style={{background:"rgba(105, 95, 95,0.1)",width:"30px",height:"30px",borderRadius:"50%",position:"absolute",right:"0px",top:"0px",
                     alignContent:"center",textAlign:"center",padding:"5px",margin:"10px",cursor:"pointer"}} onClick={()=>setShowFilterSidebar(false)} >
                        <X size={22}  color="rgb(105, 95, 95)"/></div> 
   <div className="courseFilterFlexCenter">
        <div className="CourseFilterLeftTitle">Languages {!languagesFilterOpen?<div onClick={()=>{setLanguagesFilterOpen(true)}}className="CourseFilterLeftTitleIcon"><ChevronDown size={20} strokeWidth={2} color={"rgba(255,114,94,0.71)"}/></div>:<div onClick={()=>{setLanguagesFilterOpen(false)}}className="CourseFilterLeftTitleIcon"><ChevronUp size={20} strokeWidth={2} color={"rgba(255,114,94,0.71)"}/></div>} </div>
       {languagesFilterOpen&&languagesFilter?.map(item => {
  const isChecked = filtersChips?.languageLabel?.includes(item?.post_title);

  return (
    <label key={item?.ID} className="CourseFilterLeftSubTitle" style={{ display: "block", cursor: "pointer" }}>
      <input
        type="checkbox" 
        checked={isChecked}
        onChange={() =>  toggleFilter("languageLabel", item?.post_title)}
      />
        <span className="square"></span>
      {item?.post_title}
    </label>
  );
})} 
      <div className="CourseFilterLeftTitle">Difficulty Level  {!difficultyFilterOpen?<div onClick={()=>{setDifficultyLevelFilterOpen(true)}}className="CourseFilterLeftTitleIcon"><ChevronDown size={20} strokeWidth={2} color={"rgba(255,114,94,0.71)"}/></div>:<div onClick={()=>{setDifficultyLevelFilterOpen(false)}}className="CourseFilterLeftTitleIcon"><ChevronUp size={20} strokeWidth={2} color={"rgba(255,114,94,0.71)"}/></div>} </div>
        {/* {difficultyFilter?.map((item,indexLang)=>(<div  onClick={() => toggleFilter({lang:"difficultyLabel", item:item})}   className="CourseFilterLeftSubTitle">{item?.post_title}</div>))} */}
     {difficultyFilterOpen&&difficultyFilter?.map(item => {
  const isChecked = filtersChips?.difficultyLabel?.includes(item?.post_title);

  return (
    <label key={item?.ID} className="CourseFilterLeftSubTitle" style={{ display: "block", cursor: "pointer" }}>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={() =>  toggleFilter("difficultyLabel", item?.post_title)}
      /><span className="square"></span>
      {item?.post_title}
    </label>
  );
})}  <div className="CourseFilterLeftTitle">Course Type  {!typeFilterOpen?<div onClick={()=>{setTypeFilterOpen(true)}}className="CourseFilterLeftTitleIcon"><ChevronDown size={20} strokeWidth={2} color={"rgba(255,114,94,0.71)"}/></div>:<div onClick={()=>{setTypeFilterOpen(false)}}className="CourseFilterLeftTitleIcon"><ChevronUp size={20} strokeWidth={2} color={"rgba(255,114,94,0.71)"}/></div>}</div>
     {typeFilterOpen&&typeFilter?.map(item => {
  const isChecked = filtersChips?.typeLabel?.includes(item?.post_title);

  return (
    <label key={item?.ID} className="CourseFilterLeftSubTitle" style={{ display: "block", cursor: "pointer" }}>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={() =>  toggleFilter("typeLabel", item?.post_title)}
      /><span className="square"></span>
      {item?.post_title}
    </label>
  );
})}  <div className="CourseFilterLeftTitle">Course Status  {!statusFilterOpen?<div onClick={()=>{setStatusFilterOpen(true)}}className="CourseFilterLeftTitleIcon"><ChevronDown size={20} strokeWidth={2} color={"rgba(255,114,94,0.71)"}/></div>:<div onClick={()=>{setStatusFilterOpen(false)}}className="CourseFilterLeftTitleIcon"><ChevronUp size={20} strokeWidth={2} color={"rgba(255,114,94,0.71)"}/></div>}</div>
        {statusFilterOpen&&statusFilter?.map(item => {
  const isChecked = filtersChips?.statusLabel?.includes(item?.post_title);

  return (
    <label key={item?.ID} className="CourseFilterLeftSubTitle" style={{ display: "block", cursor: "pointer" }}>
      <input
        type="checkbox"
        checked={isChecked}
        onChange={() =>  toggleFilter("statusLabel", item?.post_title)}
      /><span className="square"></span>
      {item?.post_title}
    </label>
  );
})}    
   </div> </div>:""}
<div>
    <div style={{display:"flex",justifyContent:"space-between"}} >
       
    <DropDownButtonUI activeCard={""} icon={2} title={activeDropdown} 
                   onClickSendObject={(value)=>{if(value){toggleFilter("sortBy", value);setActiveDropdown(value)}}}
                    hasDropDown={true} dropDownObject={[{title:"A-Z",value:"A-Z"},{title:"Z-A",value:"Z-A"},{title:"Newest",value:"newest"},
                     
                    ]} /> 
                     <div style={{display:"flex",justifyContent:"left"}} >
    
                    <div style={{position:"relative",display:"flex",justifyContent:"left",marginTop:"-5px",left:"-35px",marginBottom:"5px",}}>
                      <div style={{marginTop:"-5px"}}><h4>Paid </h4></div>
                                <Toggle state={statePaid} toggleState={(state)=>{  
toggleFilter("priceType", "paid");setStatePaid(state)}} />
                                   </div>
                    <div style={{position:"relative",display:"flex",justifyContent:"left",marginTop:"-5px",left:"-35px",marginBottom:"5px",}}>
                      <div style={{marginTop:"-5px"}}><h4>Free </h4></div>
                                <Toggle state={stateFree} toggleState={(state)=>{  
                                  
toggleFilter("priceType", "free");setStateFree(state)}} />
                                   </div>  </div>
                    
</div>
<div >
    
{Object?.entries(filters)?.flatMap(([type, values]) =>
          values?.map((val) => (
            <span
              key={`${type}-${val}`}
              onClick={() => {toggleFilter(type, val);if(val=="free"){setStateFree(!stateFree)};;if(val=="paid"){setStatePaid(!statePaid)}}}
              style={{
                marginRight: "8px",position:"relative",
                padding: "4px 8px",top:"10px",
                border: "1px solid rgba(144, 202, 249,1)",
                color:"rgba(144, 202, 249,1)",background:"#fff",
                borderRadius: "6px",
                cursor: "pointer",
              }}
            >
              {val}  <span style={{color:"#222"}}>✕</span>
            </span>
          ))
        )}
        <div className="courseFilterCards" style={courseThemeCard1Object?.compact?.status?{gridTemplateColumns:"48% 48%"}:{}}>
 {flattenedDataLoading?.length==0?flattenedData?.length?
flattenedData?.map((item,index)=>(<div key={item?.ID}>
<CourseCardV1 courseThemeCard1Object={courseThemeCard1Object} setCartOpen={(v)=>{setCartOpen(v)}} sendBackPopUpItem={(item)=>{setPopUpItem(item)}} course={{}} item={item} onEnroll = {() => {}} layout = 'regular' index={index} 
setItemStatus={(item)=>{
  if(item?.status){
  const enrolledProductId = String(item?.enrollment[0]?.product_id);

setItemArr(prev =>
  prev.map(course =>
    String(course.postId) === enrolledProductId
      ? { ...course, enrollStatus: "active" }
      : course
  )
)}}} />
{/* <div className="courseCard1Outer" 
 onMouseEnter={()=>{
    setTimeout(()=>{setHoverCourseCard(item?.ID)},500);
 }
 } onMouseLeave={()=>{
    setHoverCourseCard("")
 }
 }


>

    
  {item?.typeLabel?<div className="courseCardAllTypeLabel">{JSON.parse(item?.typeLabel)?.post_title}</div>:""}
  {item?.typeLabel?<div className="courseCardAllStatusLabel">{JSON.parse(item?.statusLabel)?.post_title}</div>:""}
  
{ hoverCourseCard==item?.ID?<CourseCard1MouseOver item={item} sendBackPopUpItem={(item)=>{setPopUpItem(item)}} onMouseLeaveFire={()=>{  setHoverCourseCard("")}} />:""}

   <ImageFallFB  itemOuter={{}}
                  boxShadow={``}
                  src={placeholderImg}
                  border={``}
                  width={ 100
                  }
                  aspectRatio={
                    2/1.1
                  }
                  borderRadius={
                    {
                      value: 10,
                      resolution: "%",
                    }
                  }
                /> 
                <div className="courseCard1MiddleButtons">
                           <div className="courseCard1MiddleButtons">
             {item?.languageLabel? <div className="courseCardAllLanguageLabel ">
               {JSON.parse(item?.languageLabel)?.post_title}</div>:""}
              {item?.difficultyLabel?<div className="courseCardAllDifficultyLabel">{JSON.parse(item?.difficultyLabel)?.post_title}</div>:""}
              
              </div>  </div>
                <div className="CourseAllItemTitle">{item?.productName}</div>
</div> */}
</div>)):"":""}
{flattenedDataLoading?flattenedDataLoading?.map((item, index) => 
        (<div  index={index} key={item?.ID}    >
            <div className="courseCard1Outer"  

><div className="text-linetw" style={{height:"150px",width:"100%",position:"absolute",left:"0px",top:"0px",margin:"0px",padding:"0px"}}></div>

    
 <div className="courseCardAllTypeLabel "style={{}}>loading...</div>
  <div className="courseCardAllStatusLabel" style={{background:"#fff"}}>loading...</div>
  <div>
  </div>
   <div className="courseCard1MiddleButtons"style={{position:"relative",top:"170px"}}>
                           <div className="courseCard1MiddleButtons">
              <div className="courseCardAllLanguageLabel text-linetw"></div>
              <div className="courseCardAllDifficultyLabel text-linetw"></div>
              
              </div>  </div>
                <div className="CourseAllItemTitle text-linetw" style={{position:"relative",top:"180px",width:"80%"}}></div>
</div>
  
</div>)) :""}
</div>
</div>
   <div></div>
</div>

</div>
{flattenedDataLoading?.length==0?flattenedData?.length?"": <div style={{display:"flex",justifyContent:"center"}}>
    <ErrorNotFound /> 

    </div>:""}
{popUpItem?.ID?<CourseCard1PopUp item={popUpItem} setPopUpItem={()=>{setPopUpItem({})}} />:""}
  <CartSidebar courseThemeCard1Object={courseThemeCard1Object} 
        isOpen={isCartOpen}
        cartItems={flattenedData}
        onClose={() => setCartOpen(false)}
        onRemoveItem={(id) => console.log("remove", id)}
      />
</>)
}
export default CourseCard1;